import CommonApi from '../commonApi';
const basedUrl = 'crew';
const crew = new CommonApi(basedUrl, 'расчет потребности в пропусках');
export default crew;
